let networkLink = {
    "file":"https://opdev-lineage.plaync.com",
    "local":"https://opdev-lineage.plaync.com",
    "op":"https://opdev-lineage.plaync.com",
    "rc":"https://rc-lineage.plaync.com",
    "live":"https://lineage.plaync.com",
};

const linkUrl = [
    `${networkLink[promokit.store('network')]}/events/2021/210203_fitness`,
    `${networkLink[promokit.store('network')]}/promo/lineage/210203_lintness`,
    `${networkLink[promokit.store('network')]}/promo/lineage/210203_hero`,
    "https://www.youtube.com/channel/UCEsHrY4O-6PpFjSiZNWp-EQ"
];

$(".etc-menu__list").each((idx, ele)=>{
    $(ele).find("a").attr("href", linkUrl[idx]);
});


// WEBPACK FOOTER //
// ./src/js/link.js